import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import { authSelectors } from "../redux/authorization";

export default function PublicRoute({ children, restricted = false, redirectTo = "/", ...routeProps }) {
  const isLoggedIn = useSelector(authSelectors.getIsLoggedIn);
  const shouldRedirect = isLoggedIn && restricted;
  return <Route {...routeProps}>{shouldRedirect ? <Redirect to={redirectTo} /> : children}</Route>;
}
